import React from 'react';
import { CAMPAIGN_TABS, type CampaignTabId } from '../constants/campaignTabs';

export interface CampaignTabNavProps {
  active: CampaignTabId;
  onChange: (tab: CampaignTabId) => void;
}

/**
 * In-page tabs for the unified admin Campaign area (matches app chrome, not top nav).
 */
const CampaignTabNav: React.FC<CampaignTabNavProps> = ({ active, onChange }) => {
  return (
    <nav
      className="flex flex-wrap gap-1 border-b border-charcoal/10 mb-6 shrink-0"
      aria-label="Campaign sections"
    >
      {CAMPAIGN_TABS.map((tab) => {
        const isActive = active === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.id)}
            className={`px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors rounded-t-lg ${
              isActive
                ? 'border-electric-blue text-electric-blue bg-electric-blue/5'
                : 'border-transparent text-slate-gray hover:text-charcoal hover:bg-charcoal/[0.03]'
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </nav>
  );
};

export default CampaignTabNav;
